import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { setWorklistClaimNewMessageAttachments } from '../worklistClaims/slice';
import { setWorklistRiskNewMessageAttachments } from '../worklistRisks/slice';
import { selectWorklistClaimNewMessageAttachments } from '../worklistClaims/selectors';
import { selectWorklistRiskNewMessageAttachments } from '../worklistRisks/selectors';
import { onUploadFile } from './api';

import {
  uploadFile,
  uploadFileSucceeded,
  uploadFileFailed,
  uploadFileMessageAttachment,
  uploadFileMessageAttachmentSucceeded,
  uploadFileMessageAttachmentFailed,
  clearUploadsTempContainer
} from './slice';

export function* uploadFileWorker({ payload }) {
  const { file, fileContainerId, callback, clearTempOnSuccess } = payload;
  try {
    const upload = yield call(onUploadFile, file, fileContainerId);
    if (!upload || !upload.data) {
      yield put(uploadFileFailed());
      callback?.(null);
      return;
    }

    yield put(uploadFileSucceeded(upload.data));

    callback?.(upload.data);

    if (clearTempOnSuccess) {
      yield put(clearUploadsTempContainer());
    }
  } catch (error) {
    yield put(uploadFileFailed(error));
    callback?.(null);
  }
}

export function* uploadFileMessageAttachmentWorker({ payload }) {
  const { file, attachmentId, attachmentType, messageType = 'claim' } = payload;

  try {
    // file container id is not needed for message attachments
    const fileContainerId = '';
    const upload = yield call(onUploadFile, file, fileContainerId);

    if (!upload || !upload.data) {
      yield put(uploadFileMessageAttachmentFailed());
      return;
    }

    yield put(uploadFileMessageAttachmentSucceeded(upload.data));

    const newMessageAttachment = {
      attachment_id: attachmentId,
      attachment_type: attachmentType,
      blob: upload.data
    };

    const isRiskMessage = messageType === 'risk';
    const attachmentsSelector = isRiskMessage ? getNewMessageAttachmentsRisk : getNewMessageAttachmentsClaim;
    const setMessageAttachmentsAction = isRiskMessage
      ? setWorklistRiskNewMessageAttachments
      : setWorklistClaimNewMessageAttachments;

    const newMessageAttachments = yield select(attachmentsSelector);
    const updatedMessageAttachments = [...newMessageAttachments, newMessageAttachment];
    yield put(setMessageAttachmentsAction(updatedMessageAttachments));
  } catch {
    yield put(uploadFileMessageAttachmentFailed());
  }
}

const getNewMessageAttachmentsClaim = selectWorklistClaimNewMessageAttachments;
const getNewMessageAttachmentsRisk = selectWorklistRiskNewMessageAttachments;

export default function* fileUploadSaga() {
  yield all([
    takeEvery(uploadFile.type, uploadFileWorker),
    takeEvery(uploadFileMessageAttachment.type, uploadFileMessageAttachmentWorker)
  ]);
}
